import React from 'react'
import { TabView } from 'primereact/tabview'

import './CustomTabView.css'

export default function CustomTabView({ children, onTabChange = null, activeIndex = null }) {
  const safeChildren = React.Children.toArray(children).filter(Boolean)
  return (
    <TabView
      activeIndex={activeIndex}
      className="CustomTabView"
      onTabChange={onTabChange ? e => onTabChange(e.index) : null}
    >
      {safeChildren}
    </TabView>
  )
}
